/** Misma familia visual en Equipo (Usuarios + Roles): relleno, no chips outline. */
const base =
  'inline-flex items-center justify-center rounded-lg font-semibold transition disabled:cursor-not-allowed disabled:opacity-50';

const tones = {
  primary: 'bg-teal-600 text-white hover:bg-teal-700 disabled:hover:bg-teal-600',
  secondary:
    'border border-slate-300 bg-slate-100 text-slate-800 hover:bg-slate-200 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700',
  danger: 'bg-red-600 text-white hover:bg-red-700 disabled:hover:bg-red-600',
  outline:
    'border border-slate-300 bg-transparent text-slate-700 hover:bg-slate-100 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-800',
};

const sizes = {
  row: 'min-h-8 px-3 text-xs',
  rowStack: 'min-h-11 w-full px-3 text-sm sm:min-h-8 sm:w-auto sm:text-xs',
  page: 'min-h-10 px-4 text-sm',
};

export function actionClass(
  tone: keyof typeof tones,
  size: keyof typeof sizes = 'row'
): string {
  return `${base} ${sizes[size]} ${tones[tone]}`;
}
